import callAPiBase from './base';

const collaboratorsGroupsApi = {
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/companyGroupList',
      method: 'GET',
      useToken: true,
      title: 'Group - Get List',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/companyGroupCreate',
      method: 'POST',
      useToken: true,
      title: 'Group - Create',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/companyGroupUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Group - Update',
      data,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/companyGroupDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Group - Delete',
      params,
    }),
};

export { collaboratorsGroupsApi };
export default collaboratorsGroupsApi;
